import CONFIG from './config'

const API = {}

// 记录所有别名，别名是不推荐使用的方法名！
const ALIAS = []
// 将方法配置格式化
Object.keys(CONFIG).forEach((item) => {
    let alias = CONFIG[item].alias

    API[item] = CONFIG[item]
    if (alias) {
        alias = alias.split('|')
        alias.forEach((als) => {
            if (als) {
                ALIAS.push(als)
                // name属性值即为调用bridge时传递给native的方法名
                !CONFIG[item]['name'] && (CONFIG[item]['name'] = item)
                API[als] = CONFIG[item]
            }
        })
    }
})

export {
    API,
    ALIAS
}
